import React, { useContext, useState } from "react";
import { AppContext } from "../context/app-context.tsx";
import { userService } from "../services/user-service.ts";
import { useNavigate } from "react-router-dom";

export default function LoginScreen() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { setUser } = useContext(AppContext);
  const navigate = useNavigate();

  const handleSubmit = async (event: any) => {
    event.preventDefault();

    if (!username.trim() || !password.trim()) {
      setErrorMessage("نام کاربری و رمز عبور را وارد کنید.");
      return;
    }

    setErrorMessage("");
    setIsSubmitting(true);

    const response = await userService.login(username.trim(), password);
    if (response.status) {
      setUser(response.data?.user);
      sessionStorage.setItem("user", JSON.stringify(response.data?.user));
      sessionStorage.setItem("token", response.data?.token ?? "");
      navigate("/");
    } else {
      setErrorMessage(response.message);
    }

    setIsSubmitting(false);
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-slate-950 px-4 py-10">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(99,102,241,0.3),transparent_45%)]" />
      <div className="absolute -left-24 top-20 h-64 w-64 rounded-full bg-indigo-500/20 blur-3xl" />
      <div className="absolute -bottom-24 right-0 h-72 w-72 rounded-full bg-cyan-400/10 blur-3xl" />

      <div className="relative z-10 w-full max-w-md rounded-2xl border border-white/10 bg-slate-900/70 p-8 shadow-2xl shadow-indigo-900/30 backdrop-blur-md">
        <p className="text-sm text-indigo-300">پنل مدیریت WonMov</p>
        <h1 className="mt-2 text-3xl font-bold text-white">ورود ادمین</h1>
        <p className="mt-2 text-sm text-slate-300">
          برای دسترسی به پنل، نام کاربری و رمز عبور را وارد کنید.
        </p>

        <form className="mt-8 space-y-4" onSubmit={handleSubmit}>
          <div>
            <label className="mb-2 block text-sm text-slate-300" htmlFor="username">
              نام کاربری
            </label>
            <input
              id="username"
              type="text"
              autoComplete="username"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              className="w-full rounded-xl border border-slate-700 bg-slate-950/70 px-4 py-3 text-white outline-none transition focus:border-indigo-400 focus:ring-2 focus:ring-indigo-500/30"
              placeholder="مثلا: admin"
            />
          </div>

          <div>
            <label className="mb-2 block text-sm text-slate-300" htmlFor="password">
              رمز عبور
            </label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className="w-full rounded-xl border border-slate-700 bg-slate-950/70 px-4 py-3 text-white outline-none transition focus:border-indigo-400 focus:ring-2 focus:ring-indigo-500/30"
              placeholder="********"
            />
          </div>

          {errorMessage ? (
            <div className="rounded-xl border border-rose-500/30 bg-rose-950/40 px-4 py-3 text-sm text-rose-200">
              {errorMessage}
            </div>
          ) : null}

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full rounded-xl bg-indigo-500 px-4 py-3 font-medium text-white transition hover:bg-indigo-400 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {isSubmitting ? "در حال بررسی..." : "ورود به پنل"}
          </button>
        </form>
      </div>
    </div>
  );
}